import * as THREE from 'three'
import React, { useMemo } from 'react'

import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';

const DoubleDeluxWalkInDoor = ({ width, height, trimWidth, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    
    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(width / 4, height / 2 - trimWidth);
        model.lineTo(width / 4, -height / 2);
        model.lineTo(width / 4 - trimWidth, -height / 2);
        model.lineTo(width / 4 - trimWidth, height / 2 - trimWidth);
        model.lineTo(-width / 4 + trimWidth, height / 2 - trimWidth);
        model.lineTo(-width / 4 + trimWidth, -height / 2);
        model.lineTo(-width / 4, -height / 2);
        model.lineTo(-width / 4, height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model;
    }, [width, height, trimWidth])

    const doorModel = useMemo(() => {
        let model = [];
        
        const sideModel = new THREE.Shape();
        sideModel.moveTo(-(width / 2 - 0.03) + trimWidth,  height / 2 - trimWidth);
        sideModel.lineTo(-(width / 2 - 0.03) + trimWidth,  -height / 2 + 0.03);
        sideModel.lineTo((width / 2 - 0.03) - trimWidth,  -height / 2 + 0.03);
        sideModel.lineTo((width / 2 - 0.03) - trimWidth,  height / 2 - trimWidth);
        sideModel.closePath();

        const leftSideHole = new THREE.Path();
        leftSideHole.moveTo(-(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6)), -height / 2 + height / 20);
        leftSideHole.lineTo(-(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6)), height / 2 - trimWidth - height / 10);
        leftSideHole.lineTo(-(width / 4 + ((width / 4 - trimWidth * 2) / 6)), height / 2 - trimWidth - height / 10);
        leftSideHole.lineTo(-(width / 4 + ((width / 4 - trimWidth * 2) / 6)), -height / 2 + height / 20);
        leftSideHole.closePath();

        const rightSideHole = new THREE.Path();
        rightSideHole.moveTo(width / 4 + ((width / 4 - trimWidth * 2) / 6), -height / 2 + height / 20);
        rightSideHole.lineTo(width / 4 + ((width / 4 - trimWidth * 2) / 6), height / 2 - trimWidth - height / 10);
        rightSideHole.lineTo(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6), height / 2 - trimWidth - height / 10);
        rightSideHole.lineTo(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6), -height / 2 + height / 20);
        rightSideHole.closePath();

        const upperHole = new THREE.Path();
        upperHole.moveTo(-(width / 4 - trimWidth - width / 2 / 7), 0);
        upperHole.lineTo(-(width / 4 - trimWidth - width / 2 / 7), height / 2 - trimWidth - height / 15);
        upperHole.bezierCurveTo(
            -width / 10, height / 2 - trimWidth,
            width / 10, height / 2 - trimWidth,
            (width / 4 - trimWidth - width / 2 / 7), height / 2 - trimWidth - height / 15);
        upperHole.lineTo((width / 4 - trimWidth - width / 2 / 7), 0);
        upperHole.closePath();
        
        const underHole = new THREE.Path();
        underHole.moveTo(-(width / 4 - trimWidth - width / 2 / 7), -height / 2 / 5);
        underHole.lineTo(-(width / 4 - trimWidth - width / 2 / 7), -height / 2 + height / 2 / 5);
        underHole.lineTo((width / 4 - trimWidth - width / 2 / 7), -height / 2 + height / 2 / 5);
        underHole.lineTo((width / 4 - trimWidth - width / 2 / 7), -height / 2 / 5);
        underHole.closePath();

        sideModel.holes.push(leftSideHole);
        sideModel.holes.push(rightSideHole);
        sideModel.holes.push(upperHole);
        sideModel.holes.push(underHole);

        // pattern-upper-model
        const patternUpperModel = new THREE.Shape();
        patternUpperModel.moveTo(-(width / 4 - trimWidth - width / 2 / 7 - 0.07), 0.07);
        patternUpperModel.lineTo(-(width / 4 - trimWidth - width / 2 / 7 - 0.07), height / 2 - trimWidth - height / 15 - 0.05);
        patternUpperModel.bezierCurveTo(
            -width / 10, height / 2 - trimWidth - 0.07,
            width / 10, height / 2 - trimWidth - 0.07,
            (width / 4 - trimWidth - width / 2 / 7 - 0.07), height / 2 - trimWidth - height / 15 - 0.05);
        patternUpperModel.lineTo((width / 4 - trimWidth - width / 2 / 7 - 0.07), 0.07);
        patternUpperModel.closePath();

        const windowHole = new THREE.Path();
        windowHole.moveTo(-width / 20, height / 2 - trimWidth - height / 3.5);
        windowHole.lineTo(-width / 20, height / 2 - trimWidth - height / 7);
        windowHole.lineTo(width / 20, height / 2 - trimWidth - height / 7);
        windowHole.lineTo(width / 20, height / 2 - trimWidth - height / 3.5);
        windowHole.closePath();

        patternUpperModel.holes.push(windowHole);

        // pattern-under-model
        const patternUnderModel = new THREE.Shape();
        patternUnderModel.moveTo(-(width / 4 - trimWidth - width / 2 / 7 - 0.07), -height / 2 / 5 - 0.07);
        patternUnderModel.lineTo(-(width / 4 - trimWidth - width / 2 / 7 - 0.07), -height / 2 + height / 2 / 5 + 0.07);
        patternUnderModel.lineTo((width / 4 - trimWidth - width / 2 / 7 - 0.07), -height / 2 + height / 2 / 5 + 0.07);
        patternUnderModel.lineTo((width / 4 - trimWidth - width / 2 / 7 - 0.07), -height / 2 / 5 - 0.07);
        patternUnderModel.closePath();

        model.push(sideModel);
        model.push(patternUpperModel);
        model.push(patternUnderModel);

        return model;
    }, [width, height, trimWidth])

    const doorInsideModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 4),  (height / 2 - 0.01));
        model.lineTo(-(width / 4),  -(height / 2 - 0.01));
        model.lineTo((width / 4),  -(height / 2 - 0.01));
        model.lineTo((width / 4),  (height / 2 - 0.01));
        model.closePath();

        const windowHole = new THREE.Path();
        windowHole.moveTo(-width / 20, height / 2 - trimWidth - height / 3.5);
        windowHole.lineTo(-width / 20, height / 2 - trimWidth - height / 7);
        windowHole.lineTo(width / 20, height / 2 - trimWidth - height / 7);
        windowHole.lineTo(width / 20, height / 2 - trimWidth - height / 3.5);
        windowHole.closePath();

        model.holes.push(windowHole);

        return model;
    }, [width, height, trimWidth])

    const mainWindowTrimModel = useMemo(() => {
        let model = [];
        
        const outTrimModel = new THREE.Shape();
        outTrimModel.moveTo(-(width / 20 + 0.01), height / 2 - trimWidth - height / 7 + 0.01);
        outTrimModel.lineTo(-(width / 20 + 0.01), height / 2 - trimWidth - height / 3.5 - 0.01);
        outTrimModel.lineTo((width / 20 + 0.01), height / 2 - trimWidth - height / 3.5 - 0.01);
        outTrimModel.lineTo((width / 20 + 0.01), height / 2 - trimWidth - height / 7 + 0.01);
        outTrimModel.closePath();

        const outTrimHole = new THREE.Path();
        outTrimHole.moveTo(-width / 20, height / 2 - trimWidth - height / 3.5);
        outTrimHole.lineTo(-width / 20, height / 2 - trimWidth - height / 7);
        outTrimHole.lineTo(width / 20, height / 2 - trimWidth - height / 7);
        outTrimHole.lineTo(width / 20, height / 2 - trimWidth - height / 3.5);
        outTrimHole.closePath();

        outTrimModel.holes.push(outTrimHole);
        
        const innerTrimModel = new THREE.Shape();
        innerTrimModel.moveTo(-(width / 20 - 0.01), height / 2 - trimWidth - height / 7 - 0.01);
        innerTrimModel.lineTo(-(width / 20 - 0.01), height / 2 - trimWidth - height / 3.5 + 0.01);
        innerTrimModel.lineTo((width / 20 - 0.01), height / 2 - trimWidth - height / 3.5 + 0.01);
        innerTrimModel.lineTo((width / 20 - 0.01), height / 2 - trimWidth - height / 7 - 0.01);
        innerTrimModel.closePath();

        const innerTrimHole = new THREE.Path();
        innerTrimHole.moveTo(-(width / 20 - 0.02), height / 2 - trimWidth - height / 3.5 + 0.02);
        innerTrimHole.lineTo(-(width / 20 - 0.02), height / 2 - trimWidth - height / 7 - 0.02);
        innerTrimHole.lineTo((width / 20 - 0.02), height / 2 - trimWidth - height / 7 - 0.02);
        innerTrimHole.lineTo((width / 20 - 0.02), height / 2 - trimWidth - height / 3.5 + 0.02);
        innerTrimHole.closePath();

        innerTrimModel.holes.push(innerTrimHole);

        model.push(outTrimModel);
        model.push(innerTrimModel);

        return model;
    }, [width, height, trimWidth])

    const windowModel = useMemo(() => {
        let model = [];
        
        const mainWindowModel = new THREE.Shape();
        mainWindowModel.moveTo(-width / 20, height / 2 - trimWidth - height / 3.5);
        mainWindowModel.lineTo(-width / 20, height / 2 - trimWidth - height / 7);
        mainWindowModel.lineTo(width / 20, height / 2 - trimWidth - height / 7);
        mainWindowModel.lineTo(width / 20, height / 2 - trimWidth - height / 3.5);
        mainWindowModel.closePath();

        const leftWindowModel = new THREE.Shape();
        leftWindowModel.moveTo(-(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6)), -height / 2 + height / 20);
        leftWindowModel.lineTo(-(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6)), height / 2 - trimWidth - height / 10);
        leftWindowModel.lineTo(-(width / 4 + ((width / 4 - trimWidth * 2) / 6)), height / 2 - trimWidth - height / 10);
        leftWindowModel.lineTo(-(width / 4 + ((width / 4 - trimWidth * 2) / 6)), -height / 2 + height / 20);
        leftWindowModel.closePath();

        const rightWindowModel = new THREE.Shape();
        rightWindowModel.moveTo(width / 4 + ((width / 4 - trimWidth * 2) / 6), -height / 2 + height / 20);
        rightWindowModel.lineTo(width / 4 + ((width / 4 - trimWidth * 2) / 6), height / 2 - trimWidth - height / 10);
        rightWindowModel.lineTo(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6), height / 2 - trimWidth - height / 10);
        rightWindowModel.lineTo(width / 2 - trimWidth - ((width / 4 - trimWidth * 2) / 6), -height / 2 + height / 20);
        rightWindowModel.closePath();

        model.push(mainWindowModel);
        model.push(leftWindowModel);
        model.push(rightWindowModel);

        return model;
    }, [width, height, trimWidth])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} metalness={0.5} roughness={0.6} toneMapped={false} />
            </mesh>
            <mesh name='glass-door-side' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.025, 0, 3)]} />
                <meshLambertMaterial color={'#78361A'} side={THREE.DoubleSide} />
            </mesh>
            <mesh name='glass-door-in-side' position={[0, 0, 0.1]}>
                <extrudeGeometry args={[doorInsideModel, extrudeSettings(0.1)]} />
                <meshStandardMaterial color={'#78361A'} side={THREE.DoubleSide} metalness={0.3} />
            </mesh>
            <mesh name='glass-window-trim' position={[0, 0, 0.025]}>
                <extrudeGeometry args={[mainWindowTrimModel, extrudeSettings(0.25, 0.03, 0.01, 0, 2)]} />
                <meshStandardMaterial color={'#78361A'} side={THREE.DoubleSide} metalness={0.3} />
            </mesh>
            <mesh name='glass' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[windowModel, extrudeSettings(0.2)]} />
                <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
            </mesh>

            <SphereModel width={width} height={height} trimWidth={trimWidth} />
            <RailAndFixedPointModel width={width} height={height} trimWidth={trimWidth} />
        </>
    )
}

export default DoubleDeluxWalkInDoor

const SphereModel = ({ width, height, trimWidth }) => {
    const underPatternWidth = (width / 4 - width / 2 / 7 - 0.07) * 2
    const mainPatternSphereDistance = underPatternWidth / 6;
    const mainPatternUpperSpherePosY = [
        height / 2 - trimWidth - height / 15 - 0.1,
        height / 2 - trimWidth - height / 15,
        height / 2 - trimWidth - height / 15 + 0.05,
        height / 2 - trimWidth - height / 15,
        height / 2 - trimWidth - height / 15 - 0.1,
    ]

    return (
        <>
            {new Array(2).fill("").map((_, indexI) => 
                new Array(5).fill("").map((_, indexJ) =>
                    <group key={`pattern-sphere-${indexI}-${indexJ}`} name='main-pattern-sphere' position={[-underPatternWidth / 2 + mainPatternSphereDistance * (indexJ + 1), 0, 0.03 + 0.24 * indexI]}>
                        <mesh name='upper-pattern-part-up' position={[0, mainPatternUpperSpherePosY[indexJ], 0]}>
                            <sphereGeometry args={[0.05, 32, 16]} />
                            <meshStandardMaterial color={'black'} roughness={0.3} metalness={0.2} />
                        </mesh>
                        <mesh name='upper-pattern-part-down' position={[0, 0.25, 0]}>
                            <sphereGeometry args={[0.05, 32, 16]} />
                            <meshStandardMaterial color={'black'} roughness={0.3} metalness={0.2} />
                        </mesh>
                        <mesh name='under-pattern-part-up' position={[0, -height / 2 / 5 - 0.25, 0]}>
                            <sphereGeometry args={[0.05, 32, 16]} />
                            <meshStandardMaterial color={'black'} roughness={0.3} metalness={0.2} />
                        </mesh>
                        <mesh name='under-pattern-part-down' position={[0, -height / 2 + height / 2 / 5 + 0.25, 0]}>
                            <sphereGeometry args={[0.05, 32, 16]} />
                            <meshStandardMaterial color={'black'} roughness={0.3} metalness={0.2} />
                        </mesh>
                    </group>
                )
            )}
        </>
    )
}

const RailAndFixedPointModel = ({ width, height, trimWidth }) => {
    const windowPointPosData = [
        {
            index: 0,
            x: width / 20 / 3,
            y: height / 2 - trimWidth - height / 7 + 0.1,
        },
        {
            index: 1,
            x: width / 20 / 3,
            y: height / 2 - trimWidth - height / 3.5 - 0.1,
        },
        {
            index: 2,
            x: width / 20 + 0.1,
            y: height / 2 - trimWidth - height / 7 - height / 7 * 1 / 3,
        },
        {
            index: 3,
            x: width / 20 + 0.1,
            y: height / 2 - trimWidth - height / 7 - height / 7 * 2 / 3,
        }
    ]

    const glassHeight = height - trimWidth - height / 20 * 3;
    const glassPointDistanceY = glassHeight / 6;
    
    const glassPointPosData = [
        {
            index: 0,
            x: width / 4 + ((width / 4 - trimWidth) / 2),
            y: height / 2 - trimWidth - height / 10 + 0.07
        },
        {
            index: 1,
            x: width / 4 + ((width / 4 - trimWidth) / 2),
            y: -height / 2 + height / 20 - 0.07
        },
        {
            index: 2,
            x: width / 2 - trimWidth - ((width / 4 - trimWidth) / 6) + 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 1
        },
        {
            index: 3,
            x: width / 4 + ((width / 4 - trimWidth) / 6) - 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 1
        },
        {
            index: 4,
            x: width / 2 - trimWidth - ((width / 4 - trimWidth) / 6) + 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 2
        },
        {
            index: 5,
            x: width / 4 + ((width / 4 - trimWidth) / 6) - 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 2
        },
        {
            index: 6,
            x: width / 2 - trimWidth - ((width / 4 - trimWidth) / 6) + 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 3
        },
        {
            index: 7,
            x: width / 4 + ((width / 4 - trimWidth) / 6) - 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 3
        },
        {
            index: 8,
            x: width / 2 - trimWidth - ((width / 4 - trimWidth) / 6) + 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 4
        },
        {
            index: 9,
            x: width / 4 + ((width / 4 - trimWidth) / 6) - 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 4
        },
        {
            index: 10,
            x: width / 2 - trimWidth - ((width / 4 - trimWidth) / 6) + 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 5
        },
        {
            index: 11,
            x: width / 4 + ((width / 4 - trimWidth) / 6) - 0.07,
            y: height / 2 - trimWidth - height / 10 - glassPointDistanceY * 5
        },
    ]

    return (
        <>
            <FixedPointModel windowPointPosData={windowPointPosData} glassPointPosData={glassPointPosData} />
            <RailModel windowPointPosData={windowPointPosData} glassPointPosData={glassPointPosData} />
        </>
    )
}

const FixedPointModel = ({ windowPointPosData, glassPointPosData }) => {
    return (
        <>
            {new Array(2).fill("").map((_, indexI) =>
                new Array(2).fill("").map((_, indexJ) =>
                    <group key={`window-fixed-point-${indexI}-${indexJ}`} name='window-fixed-point-model' position={[0, 0, 0.03 + 0.24 * indexJ]}>
                        {windowPointPosData.map((posData, _) =>
                            <group position={[Math.pow(-1, indexI) * posData.x, posData.y, 0]}>
                                <mesh>
                                    <sphereGeometry args={[0.025, 32, 16]} />
                                    <meshStandardMaterial color={'#3a3a3a'} roughness={0.3} metalness={0.2} />
                                </mesh>
                                <mesh rotation={[Math.PI / 2, 0, 0]}>
                                    <cylinderGeometry args={[0.05, 0.05, 0.03, 16]} />
                                    <meshStandardMaterial color={'black'} roughness={0.3} metalness={0.2} />
                                </mesh>
                            </group>
                        )}
                    </group>
                )
            )}
            {new Array(2).fill("").map((_, indexI) =>
                new Array(2).fill("").map((_, indexJ) =>
                    <group key={`glass-fixed-point-${indexI}-${indexJ}`} name='glass-fixed-point-model' position={[0, 0, 0.03 + 0.24 * indexJ]}>
                        {glassPointPosData.map((posData, _) =>
                            <group position={[Math.pow(-1, indexI) * posData.x, posData.y, 0]}>
                                <mesh>
                                    <sphereGeometry args={[0.025, 32, 16]} />
                                    <meshStandardMaterial color={'#3a3a3a'} roughness={0.3} metalness={0.2} />
                                </mesh>
                                <mesh rotation={[Math.PI / 2, 0, 0]}>
                                    <cylinderGeometry args={[0.05, 0.05, 0.03, 16]} />
                                    <meshStandardMaterial color={'black'} roughness={0.3} metalness={0.2} />
                                </mesh>
                            </group>
                        )}
                    </group>
                )
            )}
        </>
    )
}

const RailModel = ({ windowPointPosData, glassPointPosData }) => {
    const windowRailLengthV = windowPointPosData[0].y - windowPointPosData[1].y
    const windowRailLengthH = windowPointPosData[2].x * 2

    const glassRailLengthV = glassPointPosData[0].y - glassPointPosData[1].y
    const glassRailLengthH = glassPointPosData[2].x - glassPointPosData[3].x
    
    const railModel = (modelLength) => {
        const model = new THREE.Shape();
        // outer line
        model.moveTo(0, 0);
        model.lineTo(-0.1, 0.1);
        model.lineTo(-0.1, modelLength - 0.1);
        model.lineTo(0, modelLength);
        // inner line
        model.lineTo(0, modelLength - 0.02);
        model.lineTo(-0.1 + 0.02, modelLength - 0.1);
        model.lineTo(-0.1 + 0.02, 0.1);
        model.lineTo(0, 0.02);
        model.closePath();

        return model;
    }

    return (
        <>
            {new Array(2).fill("").map((_, index) =>
                <group key={`window-rail-model-${index}`} name='window-rail-model' position={[0, 0, 0.03 + 0.24 * index]}>
                    <mesh name='vertical-left' position={[-windowPointPosData[1].x, windowPointPosData[1].y, 0]} rotation={[0, -Math.pow(-1, index) * Math.PI / 2, 0]}>
                        <extrudeGeometry args={[railModel(windowRailLengthV), extrudeSettings(0.01, 0.01, 0.01, 0, 2)]} />
                        <meshStandardMaterial color={'black'}  roughness={0.5} metalness={0.2} />
                    </mesh>
                    <mesh name='vertical-right' position={[windowPointPosData[1].x, windowPointPosData[1].y, 0]} rotation={[0, -Math.pow(-1, index) * Math.PI / 2, 0]}>
                        <extrudeGeometry args={[railModel(windowRailLengthV), extrudeSettings(0.01, 0.01, 0.01, 0, 2)]} />
                        <meshStandardMaterial color={'black'} roughness={0.5} metalness={0.2} />
                    </mesh>
                    <mesh name='horizontal-upper' position={[-windowPointPosData[2].x, windowPointPosData[2].y, 0]} rotation={[-Math.pow(-1, index) * Math.PI / 2, 0, -Math.PI / 2]}>
                        <extrudeGeometry args={[railModel(windowRailLengthH), extrudeSettings(0.01, 0.01, 0.01, 0, 2)]} />
                        <meshStandardMaterial color={'black'} roughness={0.5} metalness={0.2} />
                    </mesh>
                    <mesh name='horizontal-under' position={[-windowPointPosData[3].x, windowPointPosData[3].y, 0]} rotation={[-Math.pow(-1, index) * Math.PI / 2, 0, -Math.PI / 2]}>
                        <extrudeGeometry args={[railModel(windowRailLengthH), extrudeSettings(0.01, 0.01, 0.01, 0, 2)]} />
                        <meshStandardMaterial color={'black'} roughness={0.5} metalness={0.2} />
                    </mesh>
                </group>
            )}
            {new Array(2).fill("").map((_, indexI) =>
                new Array(2).fill("").map((_, indexJ) =>
                    <group key={`glass-rail-vertical-${indexI}-${indexJ}`}>
                        <group name='glassRail-model' position={[0, 0, 0.03 + 0.24 * indexJ]}>
                            <mesh name='vertical' position={[Math.pow(-1, indexI) * glassPointPosData[1].x, glassPointPosData[1].y, 0]} rotation={[0, -Math.pow(-1, indexJ) * Math.PI / 2, 0]}>
                                <extrudeGeometry args={[railModel(glassRailLengthV), extrudeSettings(0.01, 0.01, 0.01, 0, 2)]} />
                                <meshStandardMaterial color={'black'}  roughness={0.5} metalness={0.2} />
                            </mesh>
                        </group>
                        {new Array(5).fill("").map((_, indexZ) =>
                            <group key={`glass-rail-horizontal-${indexZ}`} name='glassRail-model' position={[0, 0, 0.03 + 0.24 * indexJ]}>
                                <mesh name='horizontal' position={[Math.pow(-1, indexI) * glassPointPosData[3 + 2 * indexZ].x, glassPointPosData[3 + 2 * indexZ].y, 0]} rotation={[-Math.pow(-1, indexJ) * Math.pow(-1, indexI) * Math.PI / 2, 0, -Math.pow(-1, indexI) * Math.PI / 2]}>
                                    <extrudeGeometry args={[railModel(glassRailLengthH), extrudeSettings(0.01, 0.01, 0.01, 0, 2)]} />
                                    <meshStandardMaterial color={'black'}  roughness={0.5} metalness={0.2} />
                                </mesh>
                            </group>
                        )}
                    </group>
                )
            )}
        </>
    )
}